import { render } from "./events.html?vue&type=template&id=45a8da2d&external"
import script from "./events.js?vue&type=script&lang=js&external"
export * from "./events.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__